import { render, staticRenderFns } from "./CMCSidebarSelector.vue?vue&type=template&id=3f48b3fc&scoped=true&lang=pug"
import script from "./CMCSidebarSelector.vue?vue&type=script&lang=js"
export * from "./CMCSidebarSelector.vue?vue&type=script&lang=js"
import style0 from "./CMCSidebarSelector.vue?vue&type=style&index=0&id=3f48b3fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f48b3fc",
  null
  
)

export default component.exports